import { createModal } from '/@/core/elements/modal'

interface GenericConfirmationModalData {
  title: string
  message: string
}

const { api, component } = createModal<GenericConfirmationModalData>(
  'GenericConfirmationModal',
  () => import('./GenericConfirmationModal.vue'),
  {
    title: '',
    message: '',
  },
)

export const useGenericConfirmationModal = api
export default component
